import { routerMain } from 'constants/routerMain';
import { Button } from 'primereact/button';
import { Sidebar } from 'primereact/sidebar';
import { Link } from 'react-router-dom';
import MenubarRight from './MenubarRight';
import { Accordion, AccordionTab } from 'primereact/accordion';
import React, { useEffect, useRef } from 'react';
import { selectAuth } from 'app/slice/authSlice';
import { useSelector } from 'react-redux';
// import { Menubar } from 'primereact/menubar';

export const MenubarDemo = (props) => {
    const { menu, visibleRight, setVisibleRight, dataSocket, setHeight } = props;

    const topbarRef = useRef(null);

    useEffect(() => {
        const handleResize = () => {
            setHeight(topbarRef.current?.clientHeight < 56 ? 56 : topbarRef.current?.clientHeight);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    });
    const authData = useSelector(selectAuth);

    const start = (
        <Link className="menu-start" to={routerMain.HOME}>
            <img alt="logo" src={authData?.logo?.src} width="auto" height={authData?.logo?.height ?? 36} className="p-mr-2 logo-page"></img>
        </Link>
    );
    const startMobile = (
        <Link
            to={routerMain.HOME}
            onClick={() => {
                setVisibleRight(false);
            }}
        >
            <img alt="logo" src={authData?.logo?.src} width="auto" height={authData?.logo?.height ?? 36} className="p-mr-2 logo-page"></img>
        </Link>
    );

    const menuItem = (item, index) => {
        return (
            <div key={index} className={`menu-item ${item.className ? item.className : ''}`}>
                <div className="menu-item__link" onClick={item.command}>
                    <span className={`${item.icon} menu-item__icon`}></span>
                    <span className="p-mx-2">{item.label}</span>
                    {item.items && <span className="pi pi-angle-down angle-down-custom"></span>}
                </div>
                <div className="sub-menu">{item.items && item.items.map((e, i) => subMenuItem(e, i))}</div>
            </div>
        );
    };

    const subSubMenuItem = (item, index) => {
        return (
            <div className="sub-sub-menu-item" key={index}>
                {item.link ? (
                    <Link className="sub-sub-menu-item__link" to={item.link} onClick={item.command}>
                        <span className={`${item.icon}`}></span>
                        <span className="p-ml-2">{item.label}</span>
                    </Link>
                ) : (
                    <div className="sub-sub-menu-item__link" onClick={item.command}>
                        <span className={`${item.icon}`}></span>
                        <span className="p-ml-2">{item.label}</span>
                    </div>
                )}
            </div>
        );
    };

    const subMenuItem = (item, index) => {
        return (
            <div className={`sub-menu-item ${item.className ? item.className : ''}`} key={index}>
                {item.link ? (
                    <Link to={item.link} className="sub-menu-item__link" onClick={item.command}>
                        <span className={`${item.icon}`}></span>
                        <span className="p-ml-2">{item.label}</span>
                    </Link>
                ) : (
                    <div className="sub-menu-item__link" onClick={item.command}>
                        <span className={`${item.icon}`}></span>
                        <span className="p-mx-2">{item.label}</span>
                        {item.items && <span className="p-submenu-icon pi pi-angle-right p-ml-auto"></span>}
                    </div>
                )}
                {item.items && <div className="sub-sub-menu">{item.items.map((e, i) => subSubMenuItem(e, i))}</div>}
            </div>
        );
    };

    const subSidebarMenu = (submenu, key) => {
        return (
            <Accordion className="sidebar-sub-menu" key={key}>
                <AccordionTab
                    header={
                        <div className="sidebar-sub-header">
                            <span className={`${submenu.icon}`}></span>
                            <span className="p-mx-2">{submenu.label}</span>
                        </div>
                    }
                >
                    {submenu.items && (
                        <div className="sidebar-sub-item p-my-2">
                            {submenu.items.map((e, i) => {
                                if (e.link)
                                    return (
                                        <Link
                                            to={e.link}
                                            className="sidebar-link"
                                            key={i}
                                            onClick={() => setVisibleRight(false)}
                                        >
                                            <span className={`${e.icon}`}></span>
                                            <span className="p-ml-2">{e.label}</span>
                                        </Link>
                                    );
                                else
                                    return (
                                        <div className="sidebar-link" key={i} onClick={() => setVisibleRight(false)}>
                                            <span className={`${e.icon}`}></span>
                                            <span className="p-ml-2">{e.label}</span>
                                        </div>
                                    );
                            })}
                        </div>
                    )}
                </AccordionTab>
            </Accordion>
        );
    };

    const sidebarMenu = (item, index) => {
        return (
            <Accordion className="sidebar-menu p-mt-4">
               {menu.map((item, index) => <AccordionTab
                    className={`mobile-item ${item?.className}`}
                    key={index}
                    header={
                        <React.Fragment>
                            <span className={`${item.icon} mobile-item__nav--mr`}></span>
                            <span className="menu-item__label">{item.label}</span>
                        </React.Fragment>
                    }
                >
                    <div className="sidebar-item p-my-2">
                        {item.items &&
                            item.items.map((e, i) => {
                                if (e.link) {
                                    return (
                                        <Link
                                            to={e.link}
                                            className="sidebar-link"
                                            key={i}
                                            onClick={() => setVisibleRight(false)}
                                        >
                                            <span className={`${e.icon}`}></span>
                                            <span className="p-ml-2">{e.label}</span>
                                        </Link>
                                    );
                                } else {
                                    return <div key={i}>{subSidebarMenu(e, i)}</div>;
                                }
                            })}
                    </div>
                </AccordionTab>)}
            </Accordion>
        );
    };

    return (
        <React.Fragment>
            {/* <div ref={topbarRef} className="layout-topbar scrollpanel-demo" style={{ paddingTop: `${height}px` }}> */}
            <div ref={topbarRef} className="layout-topbar scrollpanel-demo">
                <div className="menu-customer w--100">
                    <div className="menu-wrapper">
                        <div className="p-menubar-start">{start}</div>
                        {menu.map((item, index) => {
                            return menuItem(item, index);
                        })}
                    </div>
                    <div className="MenubarDemoMobile">
                        <Button
                            icon="pi pi-bars"
                            onClick={() => setVisibleRight(true)}
                            title="Menu"
                            className="p-button-text button-menu p-button-lg"
                        />
                    </div>
                    <MenubarRight dataSocket={dataSocket} />
                </div>
            </div>

            <div className="SideBarDemoMobile">
                <Sidebar
                    className="sidebar-mobile SideBarDemoMobile"
                    visible={visibleRight}
                    position="left"
                    baseZIndex={1000000}
                    onHide={() => setVisibleRight(false)}
                >
                    {startMobile}
                    {sidebarMenu(menu)}
                </Sidebar>
            </div>
        </React.Fragment>
    );
};
